export enum AngleDirection {
  CLOCKWISE, COUNTER_CLOCKWISE
}
